import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function deleteProposition(input: { enrollmentId: number; propositionId: number }) {
  const { enrollmentId, propositionId } = input
  return restApiClient
    .url(
      constructApiUrl(API.enrollments.deleteProposition.url, { id: enrollmentId, propositionId })
    )
    .delete()
}
